import OrdemServicoListaServicos from "../../../ordem-servicos/add-ordem-servico/components/ordem-servico-lista-servicos.component";

const OrcamentoServicoListaServicos = ({
  id,
  orcamentoServico,
  orcamentoServicoEntity,
  setOrcamentoServico,
  servicoList,
  setServicoList,
  prestadoresList,
  removerServicoCadastrado,
  setListaOrcamentoServicoPagamentos,
  listaOrcamentoServicoPagamentos,
  listaOrcamentoServicoServicos,
  setListaOrcamentoServicoServicos,
  permissaoAlterarValorServico,
  isFechado,
}) => (
  <OrdemServicoListaServicos
    isFechado={isFechado}
    id={id}
    ordemServico={orcamentoServico}
    ordemServicoEntity={orcamentoServicoEntity}
    setOrdemServico={setOrcamentoServico}
    servicoList={servicoList}
    setServicoList={setServicoList}
    prestadoresList={prestadoresList}
    removerServicoCadastrado={removerServicoCadastrado}
    setListaOrdemServicoPagamentos={setListaOrcamentoServicoPagamentos}
    listaOrdemServicoPagamentos={listaOrcamentoServicoPagamentos}
    listaOrdemServicoServicos={listaOrcamentoServicoServicos}
    setListaOrdemServicoServicos={setListaOrcamentoServicoServicos}
    permissaoAlterarValorServico={permissaoAlterarValorServico}
  />
);

export default OrcamentoServicoListaServicos;
